import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';

class LoyaltyPointsLevelDescription extends React.Component {
  static propTypes = {
    selected: PropTypes.number
  };

  descriptionTitle () {
    switch (this.props.selected) {
      case 0:
        return 'LOYALTY_TITLE_1';
      case 1:
        return 'LOYALTY_TITLE_2';
      case 2:
        return 'LOYALTY_TITLE_3';
      case 3:
        return 'LOYALTY_TITLE_4';
      case 4:
        return 'LOYALTY_TITLE_5';
      case 5:
        return 'LOYALTY_TITLE_6';
      default:
        return '';
    }
  }

  descriptionText () {
    switch (this.props.selected) {
      case 0:
        return 'LOYALTY_DESCRIPTION_1';
      case 1:
        return 'LOYALTY_DESCRIPTION_2';
      case 2:
        return 'LOYALTY_DESCRIPTION_3';
      case 3:
        return 'LOYALTY_DESCRIPTION_4';
      case 4:
        return 'LOYALTY_DESCRIPTION_5';
      case 5:
        return 'LOYALTY_DESCRIPTION_6';
      default:
        return '';
    }
  }

  render () {
    return this.props.selected != null
    ? (<div className='loyalty-points-overview-description-container'>
      <div className='loyalty-points-overview-description-title'>
        <Translate content={this.descriptionTitle()} />
      </div>
      <div className='loyalty-points-overview-description'>
        <Translate content={this.descriptionText()} />
      </div>
    </div>)
    : null;
  }
}

export default LoyaltyPointsLevelDescription;



/** WEBPACK FOOTER **
 ** ./src/views/loyalty-program/overview/level-description.js
 **/